import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageSizeService {
  private readonly STORAGE_KEY = 'userPageSize';
  private defaultPageSize = 10;

  constructor() {}

  getPageSize(): number {
    const savedPageSize = localStorage.getItem(this.STORAGE_KEY);
    return savedPageSize ? +savedPageSize : this.defaultPageSize;
  }

  setPageSize(pageSize: number): void {
    localStorage.setItem(this.STORAGE_KEY, pageSize.toString());
  }
}
